import moment from 'moment';
import * as filterValidators from '../lib/filterValidators';

const { isValidPeriod, isInteger, isBoolean } = filterValidators;

export const queryParamDateFormat = 'YYYY-MM-DD';
export const viewDateFormat = 'DD.MM.YYYY';
export const changeFilterDelay = 1000;

export const filters = {
  period: {
    name: 'period',
    initialValue: [
      moment().subtract(3, 'month').add(1, 'days').format(queryParamDateFormat),
      moment().format(queryParamDateFormat),
    ],
    isValid: isValidPeriod,
  },

  search: {
    name: 'search',
    isValid: isInteger,
  },

  isNew: {
    name: 'isNew',
    isValid: isInteger,
  },

  fromNotification: {
    name: 'fromNotification',
    isValid: isInteger,
  },

  street: {
    name: 'street',
    isValid: isInteger,
  },

  house: {
    name: 'house',
    isValid: isInteger,
  },

  onlyActive: {
    name: 'onlyActive',
    isValid: isBoolean,
    initialValue: false,
  },
};
